"use client";

import { c as _c } from "react/compiler-runtime";
import { EhrInstructionsCard } from "@/src/components/ehr-instructions-card";
import { Alert, AlertDescription } from "@/src/components/shadcn/ui/alert";
import { Button } from "@/src/components/shadcn/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/src/components/shadcn/ui/tooltip";
import type { ReactNode } from "react";
interface ReferralAuthInstructionsCardProps {
  instruction: ReactNode;
  openButtonTooltip: string;
  isOpenButtonDisabled: boolean;
  isOpening: boolean;
  onOpenAuthorization: () => void;
  footer?: ReactNode;
}
export function ReferralAuthInstructionsCard(t0) {
  const $ = _c(16);
  const {
    instruction,
    openButtonTooltip,
    isOpenButtonDisabled,
    isOpening,
    onOpenAuthorization,
    footer
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="font-medium text-center text-foreground">Referral Authorization Instructions</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== instruction) {
    t2 = <Alert><AlertDescription>{instruction}</AlertDescription></Alert>;
    $[1] = instruction;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isOpening ? "Opening..." : "Open Authorization";
  let t4;
  if ($[3] !== isOpenButtonDisabled || $[4] !== onOpenAuthorization || $[5] !== t3) {
    t4 = <TooltipTrigger asChild={true}><span className="inline-flex w-full"><Button variant="outline" className="w-full border-primary text-primary hover:bg-primary/10" onClick={onOpenAuthorization} disabled={isOpenButtonDisabled}>{t3}</Button></span></TooltipTrigger>;
    $[3] = isOpenButtonDisabled;
    $[4] = onOpenAuthorization;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== openButtonTooltip) {
    t5 = <TooltipContent side="top" className="max-w-xs text-center">{openButtonTooltip}</TooltipContent>;
    $[7] = openButtonTooltip;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <TooltipProvider delayDuration={100}><Tooltip>{t4}{t5}</Tooltip></TooltipProvider>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== footer || $[13] !== t2 || $[14] !== t6) {
    t7 = <EhrInstructionsCard><div className="text-sm text-muted-foreground flex flex-col gap-4">{t1}{t2}{footer}{t6}</div></EhrInstructionsCard>;
    $[12] = footer;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}